<template>
  <div>
    <p v-if="!city">No city selected.</p>
    <div if="city">
      <b-field label="City name">
        <b-input v-model="name"></b-input>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field label="Manager name">
            <b-input v-model="manager.name"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Manager contact">
            <b-input v-model="manager.contact"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Manager email">
            <b-input v-model="manager.email"></b-input>
          </b-field>
        </div>
      </div>


      <p class="subtitle">Configs</p>
      <div class="columns">
        <div class="column">
          <b-field label="Minimum order amount">
            <b-input v-model.number="configs.minimumOrderAmount"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Delivery charges">
            <b-input v-model.number="configs.deliveryCharges"></b-input>
          </b-field>
        </div>
      </div>
      <div class="field">
        <b-switch v-model="configs.shopOpen">Shop open?</b-switch>
      </div>
      <b-field label="Message" v-if="!configs.shopOpen">
          <b-input v-model="configs.message"></b-input>
      </b-field>
      <a class="button is-primary full-width-button" :class="{'is-loading': savingCityInformation}" @click="saveCityInformation">Save</a>
    </div>
  </div>
</template>

<script>
import CityInformationService from './service';

export default {
  name: 'Information',

  created() {
    this.changeCity();

    this.$bus.$on('CITY_CHANGED', city => {
      this.changeCity(city);
    });
  },

  props: ['city'],

  data() {
    return {
      savingCityInformation: false,
      name: null,
      manager: null,
      configs: null
    };
  },

  methods: {
    changeCity(city = this.city) {
      const { name, manager, configs } = city;

      this.name = name;
      this.manager = manager;
      this.configs = configs;
    },

    saveCityInformation() {
      this.savingCityInformation = true;
      CityInformationService.saveCityInformation(
        this.city.docId,
        this.name,
        this.manager,
        this.configs
      ).then(() => {
        this.savingCityInformation = false;
        this.$toast.open('City information save successfully');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/Information/Information.vue